var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 flex-fill d-flex align-items-center justify-content-center",staticStyle:{"min-height":"90vh"}},[_c('div',{staticClass:"border d-flex flex-column p-5 rounded bg-white align-items-center"},[_c('h1',{staticClass:"mb-3 font-weight-bold"},[_vm._v("Forbidden")]),_c('span',{staticClass:"mb-4"},[_vm._v("You do not have access to this")])])])
}]

export { render, staticRenderFns }